import { Controller } from "@hotwired/stimulus"
import { useWindowResize } from "stimulus-use"
import { Tooltip } from "bootstrap"

// Connects to data-controller="layout"
export default class extends Controller {
  connect() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

    this.width = window.innerWidth
    this.height = window.innerHeight
    console.log('Window size is: ' + this.width + 'x' + this.height);

    document.addEventListener('turbo:load', () => this.handleResize())
    document.addEventListener("DOMContentLoaded", () => this.handleResize())
    document.addEventListener("turbo:frame-render", () => this.handleResize())
    document.addEventListener("change", () => this.handleResize())

    useWindowResize(this)
    
    document.addEventListener('trix-file-accept', (e) => { e.preventDefault() })
  }

  windowResize({ width, height, event }) {
    this.width = width
    this.height = height
    this.handleResize()
  }

  handleResize() {
    //console.log('Window resized to: ' + this.width + 'x' + this.height);
    if (document.getElementById("contextmenu")) {
      if (this.width < 1200) {
        document.getElementById("contextmenu").classList.add("offcanvas", "offcanvas-end")
        document.getElementById("contextmenu").firstElementChild.classList.add("offcanvas-body")
        document.getElementById("contextmenu").classList.remove("d-none")
      } else {
        document.getElementById("contextmenu").classList.remove("offcanvas", "offcanvas-end", "d-none")
        document.getElementById("contextmenu").firstElementChild.classList.remove("offcanvas-body")
      }
    }

    if (document.getElementById("breadcrumbs-buttons")) {
      if (this.width < 1200) {
        document.getElementById("breadcrumbs-buttons").classList = "btn-group";
      } else {
        document.getElementById("breadcrumbs-buttons").classList = "";
      }
    }
    if (document.getElementById("tasklist")) {
      if (this.width < 1200) {
        document.getElementById("tasklist").querySelectorAll(".btn-group").forEach(function(btnGroup) {
          btnGroup.classList.replace("btn-group", "btn-group-vertical");
        })
      } else {
        document.getElementById("tasklist").querySelectorAll(".btn-group-vertical").forEach(function(btnGroup) {
          btnGroup.classList.replace("btn-group-vertical", "btn-group");
        })
      }
    }
  }

  logout() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'push_unsubscribe' }));
    }
  }
}
